import React, { PropTypes } from 'react';
import classNames from 'classnames';

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
};

const defaultProps = {
  tag: 'div'
};

const Row = (props) => {
  const {
    className,
    tag: Tag,
    ...attributes
  } = props;

  const classes = classNames(
    className,
    'row'
  );

  return (
    <Tag {...attributes} className={classes}/>
  );
};

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

export default Row;



/** WEBPACK FOOTER **
 ** ./src/Row.jsx
 **/